import { format } from "date-fns";

/**
 *
 * @param value ISODateTimeString
 * @returns
 */

function formatISODatetime(value: string) {
  return format(new Date(value), "dd/MM/yyyy HH:mm:ss");
}

export default formatISODatetime;
